// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "./BaseButton";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
import GameUI from '../../scenes/GameUI';
/* END-USER-IMPORTS */

export default class BtnHome extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 68.5, y ?? 72.5);

    // btnHome
    const btnHome = scene.add.image(0, 0, "common", "btn.png");
    this.add(btnHome);

    // icon
    const icon = scene.add.sprite(0, 0, "common", "icon-home.png");
    icon.scaleX = 0.75;
    icon.scaleY = 0.75;
    this.add(icon);

    // lists
    const desktopVisibleList: Array<any> = [];
    const mobileVisibleList: Array<any> = [];

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.desktopVisibleList = desktopVisibleList;
    thisUIButton.mobileVisibleList = mobileVisibleList;
    thisUIButton.pulseScaleEnd = 1.1;
    thisUIButton.pulseSpeed = 1000;

    this.desktopVisibleList = desktopVisibleList;
    this.mobileVisibleList = mobileVisibleList;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private desktopVisibleList: Array<any>;
  private mobileVisibleList: Array<any>;

  /* START-USER-CODE */

  public awake() {
    this.once(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.Home);
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
